import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-circle-semifilled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd", transform: "translate(1 1)" },
        React.createElement("circle", { cx: 7.5, cy: 7.5, r: 7.5, opacity: 0.1 }),
        React.createElement("path", { fillRule: "nonzero", d: "M10 7a.5.5 0 1 1 0 1H4.5a.5.5 0 0 1 0-1H10Z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", d: "m10.5 7.5-2-2v4z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
